export default {"src":"/_next/static/media/logo-shinhan.f4df23ba.svg","height":120,"width":197,"blurWidth":0,"blurHeight":0};